

import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { InHubScanGenerateRequestInterface, postManifestRequestInterface } from "../contracts/HubToHubRequest";
/* eslint-disable @typescript-eslint/camelcase */

export class GenerateInHubScanRequest
  implements InHubScanGenerateRequestInterface {
  scanNo = "";
  status = "IN-HUB";

  constructor(fields?: Partial<GenerateInHubScanRequest>) {
    Object.assign(this, fields);
  }
    toJSON(): string {
    const payload = {
      scan_no: this.scanNo,
      status: this.status,
      hub_id: getHubData().hubId ? Number(getHubData().hubId) : 0,
      hub_name: getHubData().hubName || "",
      hub_district_code: getHubData().hubDistrictCode || "",
      hub_origin_city: getHubData().originCity || ""
    };

    return JSON.stringify(payload);
  }
}

export class AddProsesManifest implements postManifestRequestInterface {
  hubId = "";
  status = "";
  plateNumber = "";
  hub = "" as any;

  constructor(fields?: Partial<AddProsesManifest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    const jsonObj: any = {
    hub_id: this.hubId,
    status: this.status,
    plate_number: this.plateNumber,
  };

  if (this.status !== "IN-HUB") {
    jsonObj.destination_hub_id = this.hub?.hubId;
    jsonObj.destination_hub_city = this.hub?.hubCityCode;
    jsonObj.destination_hub_type = this.hub?.hubType;
    jsonObj.destination_hub_name = this.hub?.hubName;
  }
  
    return JSON.stringify(jsonObj);
  }
}
